import React,{useCallback,useEffect,useRef,useState} from 'react';
import {Alert,Button,CircularProgress,MenuItem,Stack,TextField,Typography} from '@mui/material';
import api from '../../../controllers/trackingV2';
import Session from './trackingSession';
import MaterialPanel from './materialTraceabilityPanel';
import {useTrackingNavigation} from '../../trackingNavigation';

const noop=()=>{};
// A production selector cannot switch into QA. QA screens keep their separate
// entry points; this is navigation separation, not an additional permission.
export function stationsFor(catalog,screen,source){
 const current=catalog.stations||[],available=catalog.availableStations||[];
 const ordered=[...current,...available.filter(s=>!current.some(c=>c.code===s.code))];
 return ordered.filter(s=>s.kind!=='LABEL'&&(source==='AUTO'||s.sources.includes(source))&&(
  screen==='PRODUCTION'?s.kind==='PRODUCTION':screen==='QA_FINAL'?s.code==='QA_FINAL':
  screen==='QA_INSPECTION'&&s.kind==='QUALITY'&&s.code!=='QA_FINAL'));
}

// Candidate composition. The existing main/QA holders must supply legacy
// rendering and use onBusy to block their own navigation before this is mounted.
export default function TrackingWorkspace({screen='PRODUCTION',routeApi=api,renderLegacy,onBusy=noop}){
 const {setBusy:holderBusy}=useTrackingNavigation();
 const [catalog,setCatalog]=useState(null),[error,setError]=useState(''),[station,setStation]=useState('');
 const source='AUTO'; // Always resolve Candid and Kline; no operator filtering.
 const [busy,setBusy]=useState(false),[legacy,setLegacy]=useState(null);
 const [material,setMaterial]=useState({machine:null,ready:false}),[refresh,setRefresh]=useState(0);
 const busyRef=useRef(false),onBusyRef=useRef(onBusy);onBusyRef.current=onBusy;
 const pending=useCallback(value=>{busyRef.current=value;setBusy(value);holderBusy(value);onBusyRef.current(value);},[holderBusy]);
 useEffect(()=>{
  let live=true;
  routeApi.routes().then(result=>{
   if(!live)return;
   if(typeof result.active!=='boolean'||!Array.isArray(result.stations)||!Array.isArray(result.availableStations))throw Error('INVALID_CATALOG');
   setCatalog(result);
  }).catch(()=>{if(live)setError('No se pudo consultar la ruta. No se habilitó el escaneo; vuelve a intentar.');});
  return()=>{live=false;};
 },[routeApi]);
 useEffect(()=>{
  const prevent=e=>{if(busyRef.current){e.preventDefault();e.returnValue='';}};
  window.addEventListener('beforeunload',prevent);
  return()=>{window.removeEventListener('beforeunload',prevent);holderBusy(false);onBusyRef.current(false);};
 },[holderBusy]);
 const onLegacy=useCallback(order=>setLegacy(order),[]);
 const completed=useCallback(()=>setRefresh(n=>n+1),[]);
 if(error)return <Alert severity='error'>{error}</Alert>;
 if(!catalog)return <CircularProgress aria-label='Consultando estaciones'/>;
 if(!catalog.active)return renderLegacy?renderLegacy({active:false,screen,onBusy:pending}):<Alert severity='info'>El nuevo flujo no está activado.</Alert>;
 const stations=stationsFor(catalog,screen,source),selected=stations.find(s=>s.code===station);
 return <Stack spacing={2} sx={{p:2}}>
  <TextField select label='Estación' value={selected?station:''} disabled={busy||!!legacy} onChange={e=>{setStation(e.target.value);setMaterial({machine:null,ready:false});}}>
   {stations.map(s=><MenuItem key={s.code} value={s.code}>{s.name}{!catalog.stations.some(c=>c.code===s.code)?' · ruta anterior':''}</MenuItem>)}
  </TextField>
  {selected&&<Typography variant='h4'>{selected.name}</Typography>}
  {legacy?(renderLegacy?renderLegacy({active:true,screen,station,order:legacy,onBusy:pending,onDone:()=>{if(!busyRef.current)setLegacy(null);}}):<Alert severity='warning'>Esta orden continúa en el flujo anterior. Su integración todavía no está disponible.</Alert>):selected&&<>
   {station==='MACHINING'&&<fieldset disabled={busy} style={{border:0,padding:0,margin:0}}><MaterialPanel onStateChange={setMaterial} refreshKey={refresh}/></fieldset>}
   <Session key={`${screen}:${station}:${source}`} station={station} source={source} machineId={material.ready?material.machine?.id:undefined} onLegacy={onLegacy} onPending={pending} onRegistered={completed}/>
  </>}
  {legacy&&<Button disabled={busy} onClick={()=>setLegacy(null)}>Volver al escáner</Button>}
 </Stack>;
}
